import React from 'react';
import ReactDOM from 'react-dom'
import Form from './Form';

ReactDOM.render(
  <React.StrictMode>
    <Form />
  </React.StrictMode>,
  document.getElementById('okta-sign-in')
)
